import { Spinner } from '@cian/ui-kit';

import { FC, ReactNode } from 'react';

import styles from './ListingLayout.css';

type ListingLayoutProps = {
  banners: ReactNode;
  navigation: ReactNode;
  cards: ReactNode;
  similarCards: ReactNode;
  isFetching: boolean;
  pagination: ReactNode;
  seo: ReactNode;
  renderNoCards(): JSX.Element;
  /**
   * @todo Удалить пропсу
   * @description Данный функционал появился в задаче CD-162876, будет удалён в задаче CD-162894
   */
  toLegacyListing?: ReactNode;
};

export const ListingLayout: FC<ListingLayoutProps> = props => {
  const { banners, navigation, cards, pagination, seo, isFetching, toLegacyListing, similarCards, renderNoCards } =
    props;

  return (
    <section className={styles['container']}>
      {
        /**
         * @todo Удалить блок
         * @description Данный функционал появился в задаче CD-162876, будет удалён в задаче CD-162894
         */
        <div className={styles['to-legacy-listing-wrapper']}>{toLegacyListing}</div>
      }
      <div className={styles['navigation-wrapper']} data-testid="listing.navigation-wrapper">
        {navigation}
      </div>
      <div className={styles['seo-wrapper']}>{seo}</div>
      <div className={styles['banners-wrapper']}>{banners}</div>
      {cards ? (
        <div className={styles['cards-wrapper']}>{cards}</div>
      ) : (
        <div className={styles['no-cards-wrapper']}>{renderNoCards()}</div>
      )}
      <div className={styles['pagination-wrapper']}>{pagination}</div>
      {!!similarCards && <div className={styles['similar-cards-wrapper']}>{similarCards}</div>}
      {isFetching && (
        <div className={styles['preload-overlay']}>
          <div className={styles['preload-spinner-container']}>
            <Spinner size={50} />
          </div>
        </div>
      )}
    </section>
  );
};
